import timestamp from './timestamp'
import date from './date'

export default {
  timestamp,
  date,

  /**
   * 生成随即 ID
   */
  guid () {
    return '_xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      let r = Math.random() * 16 | 0
      let v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    }).toLowerCase()
  },

  /**
   * 获取 dom offset
   */
  offset (dom) {
    let res = {
      left: dom.offsetLeft || 0,
      top: dom.offsetTop || 0
    }

    let parent = dom.offsetParent

    while (parent) {
      res.left += parent.offsetLeft
      res.top += parent.offsetTop
      parent = parent.offsetParent
    }

    res.right = res.left + dom.offsetWidth
    res.bottom = res.top + dom.offsetHeight

    res.width = dom.offsetWidth
    res.height = dom.offsetHeight

    return res
  },
  /**
   * 节流函数
   * @param {Function} callback 执行函数
   * @param {Number}   time     间隔时间
   */
  throttle (callback, time = 60) {
    let running = false

    return () => {
      if (running) return

      running = true

      setTimeout(() => {
        callback()
        running = false
      }, time)
    }
  },
  /**
   * 截取指定长度的字符串
   *
   * 该截取方法区分全半角字符，需要将全角字符的长度 x2
   *
   * @param    {string}  str 要截取的字符串
   * @param    {number}  len 要截取的字符串长度
   * @return   {string}      截取完毕的字符串
   */
  subString (str, len, dot) {
    let str2 = str.slice(0, len)
    let i = str2.replace(/[x00-xff]/g, '').length
    let strDot = dot && str.length > len / 2 ? '...' : ''

    switch (i) {
      // 全是英文或者数字
      case 0: return str2 + strDot
      case len: return str.slice(0, len >> 1) + strDot
      default:
        let k = len - i
        let str3 = str.slice(k, len)
        let j = str3.replace(/[x00-xff]/g, '').length
        return (j ? str.slice(0, k) + this.subString(str3, j) : str.slice(0, k)) + strDot
    }
  },
  /**
   * 获取滑动的方向
   * @param {Number} startx 滑动坐标
   * @param {Number} starty 滑动坐标
   * @param {Number} endx   滑动坐标
   * @param {Number} endy   滑动坐标
   * @return result [0:未滑动,1:向上,2:向下,3:向左,4:向右]
   */
  getTouchDirection (startx, starty, endx, endy) {
    let result = 0
    const angx = endx - startx
    const angy = endy - starty

    // 如果滑动距离太短
    if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
      return result
    }

    const angle = Math.atan2(angy, angx) * 180 / Math.PI

    if (angle >= -135 && angle <= -45) {
      result = 1
    } else if (angle > 45 && angle < 135) {
      result = 2
    } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
      result = 3
    } else if (angle >= -45 && angle <= 45) {
      result = 4
    }

    return result
  },
  disableBodyScroll: (() => {
    const preventDefault = (event) => {
      event.preventDefault()
    }

    return {
      on () {
        document.body.addEventListener('touchmove', preventDefault, {
          passive: false
        })
      },
      off () {
        document.body.removeEventListener('touchmove', preventDefault, {
          passive: false
        })
      }
    }
  })(),
  fixedBody: ((className) => {
    var scrollTop = 0
    var bodyTop = 0

    return {
      open () {
        scrollTop = document.scrollingElement.scrollTop || document.body.scrollTop
        document.body.style.top = -scrollTop + 'px'
        document.body.classList.add(className)
        bodyTop = document.body.style.top
      },
      close () {
        document.body.classList.remove(className)
        document.scrollingElement.scrollTop = scrollTop
        document.body.scrollTop = scrollTop
        document.body.style.top = bodyTop
      }
    }
  })('fixed')
}
